<template>
  <v-menu
    v-model="show"
    :close-on-content-click="false"
    :activator="activator"
    offset-x
  >
    <edit-form
      ref="form"
      :item="item"
      :readonly="readonly"
      :submit-api="submitApi"
      @submit="onSubmit"
      @update:item="onUpdateItem"
    >
      <template #header>
        <v-toolbar :color="color" dark>
          <v-toolbar-title>
            {{ item.classroom.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
    </edit-form>
    <!-- <v-card flat min-width="600px">
      <v-toolbar :color="color" dark>
        <v-toolbar-title>
          {{ item.classroom.name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" :disabled="isLoading || readonly">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="6">
                <div class="label mb-2">Class Date</div>
                <v-menu
                  ref="classDateMenu"
                  v-model="classDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.class_date"
                      :rules="[validationRules.required]"
                      placeholder="Select class date"
                      prepend-icon="mdi-calendar"
                      solo
                      flat
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.class_date"
                    @change="$refs.classDateMenu.save($event)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <div class="label mb-2">Class Time</div>
                <v-row align="center">
                  <v-col cols="auto">
                    <time-picker
                      v-model="form.start_time"
                      class="vue__time-picker--dense"
                      input-width="100px"
                      close-on-complete
                      manual-input
                      :disabled="isLoading || readonly"
                    />
                  </v-col>
                  <span>-</span>
                  <v-col cols="auto">
                    <time-picker
                      v-model="form.end_time"
                      class="vue__time-picker--dense"
                      input-width="100px"
                      close-on-complete
                      manual-input
                      :disabled="isLoading || readonly"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <div class="label mb-2">Term</div>
                <v-text-field
                  v-model="form.term"
                  type="number"
                  :rules="[validationRules.required]"
                  :disabled="readonly"
                  solo
                  flat
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="4">
                <div class="label mb-2">Month</div>
                <v-text-field
                  v-model="form.month"
                  type="number"
                  :rules="[validationRules.required]"
                  :disabled="readonly"
                  solo
                  flat
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="4">
                <div class="label mb-2">Session</div>
                <v-text-field
                  v-model="form.session"
                  type="number"
                  :rules="[validationRules.required]"
                  :disabled="readonly"
                  solo
                  flat
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end">
            <v-col md="4" cols="12">
              <v-btn
                block
                depressed
                outlined
                :href="
                  hasPermission('classroom-schedules.update')
                    ? $route('classroom-schedules.update', item.id)
                    : $route('classroom-schedules.detail', item.id)
                "
              >
                View Details
              </v-btn>
            </v-col>
            <v-col v-if="!readonly" md="4" cols="12">
              <v-btn
                block
                depressed
                color="primary"
                :disabled="isLoading"
                @click="submit"
              >
                Save Changes
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card> -->
  </v-menu>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import EditForm from '@components/ClassroomSchedule/EditForm'
export default {
  name: 'ClassroomScheduleEventMenu',
  components: {
    EditForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
      default: () => ({
        classroom: {},
      }),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    activator: undefined,
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    submitApi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      classDateMenu: false,
      form: {
        classroom_id: null,
        class_date: null,
        start_time: '',
        end_time: '',
        term: null,
        month: null,
        session: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'classroomSchedule/isDetailLoading',
      schedule: 'classroomSchedule/detail',
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.$refs.form.init()
      },
    },
  },
  //   created() {
  //     this.init()
  //   },
  methods: {
    ...mapActions({
      updateSchedule: 'classroomSchedule/update',
      handleError: 'handleError',
    }),
    // init() {
    //   _.merge(this.form, this.item)
    // },
    onSubmit(data) {
      this.$emit('submit', data)
    },
    onUpdateItem(data) {
      this.$emit('update:item', data)
    },
  },
}
</script>
